import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Marquee Animation
const marqueeAnimation = (className = '') => {
   let animation;

   if (animation) {
      animation.kill();
   }

   const marquee = document.querySelectorAll(className);

   if (marquee.length) {
      marquee.forEach((el) => {
         const content = el.querySelector(
            ".marquee-wrapper",
         );
         const reverse = el.classList.contains('marquee-reverse');

         const clone1 = content.cloneNode(true)
         const clone2 = content.cloneNode(true)

         el.append(clone1, clone2);

         const contentWidth = content.offsetWidth;
         el.style.width = `${contentWidth * 3}px`;

         animation = gsap.to(el, {
            x: reverse ? contentWidth : -contentWidth,
            duration: contentWidth / 80,
            ease: "linear",
            repeat: -1,
            modifiers: {
               x: (x) => `${parseFloat(x) % contentWidth}px`,
            },
         });
      })
   }
}

// Marquee Animation
const marqueeAnimationY = (className = '') => {
   let animation;

   if (animation) {
      animation.kill();
   }

   const marquee = document.querySelectorAll(className);

   if (marquee.length) {
      marquee.forEach((el) => {
         const content = el.querySelector(
            ".marquee-wrapper",
         );
         const reverse = el.classList.contains('marquee-reverse');

         const clone1 = content.cloneNode(true)
         const clone2 = content.cloneNode(true)
         const clone3 = content.cloneNode(true)
         const clone4 = content.cloneNode(true)
         const clone5 = content.cloneNode(true)
         const clone6 = content.cloneNode(true)

         el.append(clone1, clone2, clone3, clone4, clone5, clone6);

         const contentHeight = content.offsetHeight;
         el.style.height = `${contentHeight * 3}px`;

         animation = gsap.to(el, {
            y: reverse ? contentHeight : -contentHeight,
            duration: contentHeight / 80,
            ease: "linear",
            repeat: -1,
            modifiers: {
               y: (y) => `${parseFloat(y) % contentHeight}px`,
            },
         });
      })
   }
}

document.addEventListener("DOMContentLoaded", marqueeAnimation('.marquee'), marqueeAnimationY('.marquee-y'));
document.addEventListener("resize", marqueeAnimation('.marquee'), marqueeAnimationY('.marquee-y'));

// Image Gallery
const galleries = document.querySelectorAll('.image-gallery');

galleries?.forEach(gallery => {
   const children = gallery.querySelectorAll(':scope > ul');
   
   const animation = gsap.to(children, {
      xPercent: -100,
      duration: 20,
      ease: "none",
      repeat: -1,
      paused: true
   });

   window.addEventListener('scroll', (e) => {
      const galleryPos = gallery.getBoundingClientRect();
      if (galleryPos.top < window.innerHeight * 0.5) {
         animation.resume();
      }
   })

   gallery.addEventListener('mouseover', () => animation?.pause());
   gallery.addEventListener('mouseleave', () => animation?.resume());
})

// Scroll Text/Image Change
const scrollContainer = document.querySelector('.scroll-container');

if (scrollContainer) {
   const scrollItems = scrollContainer.querySelectorAll('.scroll-item');
   const totalItems = scrollItems.length;
   const containerHeight = scrollContainer.getBoundingClientRect().height;
   const extraScroll = totalItems * 300;
   const scrollHeight = containerHeight + extraScroll;

   gsap.set(scrollContainer, { height: scrollHeight })

   ScrollTrigger.create({
      trigger: scrollContainer,
      start: "top top",
      end: () => `+=${extraScroll}`,
      scrub: true,
      onUpdate: (self) => {
         const progress = self.progress;
         const index = Math.floor(progress * totalItems);

         scrollItems.forEach((item, i) => {
            item.classList.toggle("active", i === index);
            if (progress <= 0.001) {
               item.classList.remove("active");
            }
         });
      },
   })

   scrollItems.forEach((item) => {
      item.addEventListener('mouseover', () => {
         scrollItems.forEach(item => item.classList.remove('active'))
         item.classList.add('active');
      })
   })
}

// Updates
const updatesCarousel = document.querySelector('#updates-carousel');
let updatesAnimation;

if (updatesCarousel) {
   const group = updatesCarousel.querySelector('#group');
   const clone1 = group.cloneNode(true);
   updatesCarousel.appendChild(clone1);
   const groupWidth = group.getBoundingClientRect().width;
   const speed = groupWidth / 100;

   updatesAnimation = gsap.to(updatesCarousel, {
      x: -groupWidth,
      duration: speed,
      ease: 'linear',
      repeat: -1,
   });

   updatesCarousel.addEventListener('mouseenter', () => updatesAnimation.pause());
   updatesCarousel.addEventListener('mouseleave', () => updatesAnimation.play());
}